import { ENTER } from "@angular/cdk/keycodes";
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatChipInputEvent } from "@angular/material/chips";
import { MatExpansionPanel } from "@angular/material/expansion";
import * as E from "linq";
import { Observable } from "rxjs";
import { debounceTime, distinctUntilChanged, finalize, map, switchMap, tap } from "rxjs/operators";
import { GlobalSearchResultTypeEnum } from "../../../../portal/search-api/models/global-search-result-type-enum";
import { CompanyService } from "../../../../portal/search-api/services/company.service";
import { SuggestService } from "../../../../portal/search-api/services/suggest.service";
import {
  formatTitleCaseWords,
  shouldFormatAsTitleCaseField,
} from "../../utils/text-formatting";

type FilterItem = {
  checked: boolean;
  disabled: boolean;
  caption: string;
};

@Component({
  selector: "filter-checkbox-list",
  templateUrl: "./filter-checkbox-list.component.html",
  styleUrls: ["./filter-checkbox-list.component.scss"],
})
export class FilterCheckboxListComponent implements OnChanges, OnInit {

  @Input() title: string;
  @Input() collapsed: boolean = true;
  @Output() toggled = new EventEmitter();
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes = [ENTER] as const;
  isLoading = false;
  chips: FilterItem[] = [];
  companyRequest:any;
  locationRequest:any;
  personNameRequest:any;

  suggestionResponse: any;
  @Input() items: FilterItem[];
  @Input() searchType:string;

  @Output() changed = new EventEmitter<{ items: FilterItem[] }>();

  innerItems: FilterItem[];
  searchItem: string;
  myControl = new FormControl();
  companySearchControl = new FormControl();
  locationSearchControl = new FormControl();
  personSearchControl = new FormControl();
  filteredOptions: Observable<FilterItem[]>;
  expanded :boolean = false;

  @ViewChild(MatExpansionPanel) matExpansionPanel: MatExpansionPanel;


  constructor(  private searchService: CompanyService, private suggestService:SuggestService) {


  }

  ngOnInit() {

      this.filteredOptions = this.myControl.valueChanges.pipe(
        map((value) => this._filter(value)),
      );

      this.companySearchControl.valueChanges.pipe(

        debounceTime(300),
        distinctUntilChanged(),
        tap(() => {
          this.companyRequest = {
            entity:GlobalSearchResultTypeEnum[this.searchType],
            field:"companyName",
            search:this.companySearchControl.value,
            limit:50
          };

        }),

        switchMap(value => this.suggestService.suggest(this.companyRequest).pipe(
          finalize(() => this.isLoading = false),
          )
        )
      ).subscribe(response => this.suggestionResponse = response);

    this.locationSearchControl.valueChanges.pipe(

      debounceTime(500),
      distinctUntilChanged(),
      tap(() => {
        this.locationRequest = {
          entity:GlobalSearchResultTypeEnum[this.searchType],
          field:"location",
          search:this.locationSearchControl.value,
          limit:20
          }

      }),

      switchMap(value => this.suggestService.suggest(this.locationRequest).pipe(
        finalize(() => this.isLoading = false),
        )
      )
    ).subscribe(response => this.suggestionResponse = response);
    this.personSearchControl.valueChanges.pipe(

      debounceTime(500),
      distinctUntilChanged(),
      tap(() => {
        this.personNameRequest = {
          entity:GlobalSearchResultTypeEnum[this.searchType],
          field:"name",
          search:this.personSearchControl.value,
          limit:20
        }

      }),

      switchMap(value => this.suggestService.suggest(this.personNameRequest).pipe(
        finalize(() => this.isLoading = false),
        )
      )
    ).subscribe(response => this.suggestionResponse = response);
  }
  private _filter(value: string): FilterItem[] {
    return this.innerItems.filter((option) =>
      option.caption.toLowerCase().includes(value.toLowerCase())
    );

  }
  toggledChange(){
    this.toggled.emit()
  }
  selectItem(item: FilterItem) {

    if ( !item.checked){
      this.addToChip({value: item.caption} as MatChipInputEvent);
    }
    else{
      let chip:any = this.chips.find(x=>x.caption == item.caption);
      this.remove(chip);
    }

    /*if (item.checked){
      this.remove(item);
    }*/



  }
  ngOnChanges(changes: SimpleChanges): void {

    if ("items" in changes) {
      const currentValue: FilterItem[] = changes.items.currentValue;
      this.innerItems = E.from(currentValue)
        .select((i) => ({ ...i }))
        .toArray();
      let chipsNamesArray = E.from(this.chips).select((i) => ({...i})).toArray().map(x=>x.caption);
      let unChecked = E.from(this.innerItems)
        .where(x =>  chipsNamesArray.includes(x.caption))
        .where(y=>y.checked == false)
        .toArray();

      unChecked.forEach( (value) => {
        this.remove(value);
    });
    }
  }


  addToChip(event: MatChipInputEvent): void {
    console.log("there", event.value);
    const value = (event.value || "").trim();

    if (value) {
      this.chips.filter((chip) => chip.caption === value).length > 0
        ? ""
        : this.chips.push({ caption: value, disabled: false, checked: false });
    }
  }

  remove(item: FilterItem): void {
    const index = this.chips.findIndex(x=>x.caption == item.caption);
    if (index >= 0) {
      this.chips.splice(index, 1);
      this.innerItems = this.innerItems.map((option) => {
        if (option.caption === item.caption) {
          if (  option.checked )
              option.checked = false;
        }
        return option;
      });
      this.changed.emit({ items: this.innerItems });
    }
  }


  resetSearchResults() {

    this.suggestionResponse = [];

  }
  selectCompany(companyName: any) {

    console.log("Selcted Company: " + companyName);
    for ( let i=0; i < this.innerItems.length; i++){
      if (!this.innerItems[i].checked){
        this.innerItems[i].checked = true;
        this.innerItems[i].caption = companyName;
        break;
      }
    }
    this.addToChip({value: companyName} as MatChipInputEvent);
    this.changed.emit({ items: this.innerItems });
  }
  selectPerson(personName: any) {
    console.log("Selcted Person: " + personName);
    for ( let i=0; i < this.innerItems.length; i++){
      if (!this.innerItems[i].checked){
        this.innerItems[i].checked = true;
        this.innerItems[i].caption = personName;
        break;
      }
    }
    this.addToChip({value: personName} as MatChipInputEvent);
    this.changed.emit({ items: this.innerItems });
  }
  selectLocation(locationName: any) {
    console.log("Selcted Location: " + locationName);
    for ( let i=0; i < this.innerItems.length; i++){
      if (!this.innerItems[i].checked){
        this.innerItems[i].checked = true;
        this.innerItems[i].caption = locationName;
        break;
      }
    }

    this.addToChip({value: locationName} as MatChipInputEvent);
    this.changed.emit({ items: this.innerItems });
  }

  displayCaption(caption: string): string {
    if (shouldFormatAsTitleCaseField(this.filterField)) {
      return formatTitleCaseWords(caption);
    }

    return caption;
  }

  get filterField(): string {
    if (this.title === "Country" || this.title === "Countries") {
      return "country";
    }

    if (this.title === "Location" || this.title === "Locations") {
      return "location";
    }

    return "";
  }
}
